import _, { values } from 'lodash';
import React from 'react';
import update from 'react-addons-update';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import {Style} from 'radium';
import Handsontable from 'handsontable';
import {HotTable} from '@handsontable/react';

import * as styles from '../../styles';
import Tree from '../tree';
import {request} from '../../containers/actions';


const [
    FIRSTNAME_COLUMN,
    LASTNAME_COLUMN,
    NATIONAL_ID_COLUMN,
    CLASS_COLUMN,
    GENDER_COLUMN,
    FATHER_NAME_COLUMN,
    USERNAME_COLUMN,
    PASSWORD_COLUMN,
    ADDRESS_COLUMN,
    CELL_PHONE_COLUMN,
    EMAIL_COLUMN,
    ID_COLUMN,
] = _.map(Array(12), (__, index) => index);
const FIELDS = {
    [FIRSTNAME_COLUMN]: 'firstname',
    [LASTNAME_COLUMN]: 'lastname',
    [NATIONAL_ID_COLUMN]: 'national_id',
    [CLASS_COLUMN]: 'clazz',
    [GENDER_COLUMN]:'gender',
    [FATHER_NAME_COLUMN]: 'father_name',
    [USERNAME_COLUMN]: 'username',
    [PASSWORD_COLUMN]: 'password',
    [ADDRESS_COLUMN]: 'address',
    [CELL_PHONE_COLUMN]: 'cell_phone',
    [EMAIL_COLUMN]: 'email',
    [ID_COLUMN]: 'id',
};
const COLUMNS = {
    firstname: FIRSTNAME_COLUMN,
    lastname: LASTNAME_COLUMN,
    national_id: NATIONAL_ID_COLUMN,
    clazz: CLASS_COLUMN,
    gender:GENDER_COLUMN,
    father_name: FATHER_NAME_COLUMN,
    username: USERNAME_COLUMN,
    password: PASSWORD_COLUMN,
    address: ADDRESS_COLUMN,
    cell_phone: CELL_PHONE_COLUMN,
    email: EMAIL_COLUMN,
    id: ID_COLUMN,
};

function checkValue(row, col, value, data) {
    switch (col) {
    case FIRSTNAME_COLUMN: case LASTNAME_COLUMN:
        return value && /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF ‌]{2,128}$/.test(value);
    case NATIONAL_ID_COLUMN:
        return !_.some(data, (row_, index) => index !== row && row_[col] === value) && value && /^[۰-۹]{10}$/.test(value);
    case CLASS_COLUMN:
        return value && /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF۰-۹]{1,128}$/.test(value);
    case GENDER_COLUMN:
        return value && (value=="۲" || value=="۱")
    case FATHER_NAME_COLUMN:
        return !value || /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF ‌]{2,128}$/.test(value);
    case USERNAME_COLUMN:
        return !value || _.countBy(data, row => row[col] === value)[true] <= 1 && /^([\w@\.]{6,255}|[۰-۹]{10})$/.test(value);
    case PASSWORD_COLUMN:
        return !value || value.length >= 6;
    case ADDRESS_COLUMN:
        return !value || /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF۰-۹ ‌،,\-+_\/|\\\(\)]{1,512}$/.test(value);
    case CELL_PHONE_COLUMN:
        return !value || _.countBy(data, row => row[col] === value)[true] <= 1 && /^۰۹[۰-۹]{9}$/.test(value);
    case EMAIL_COLUMN:
        return !value || _.countBy(data, row => row[col] === value)[true] <= 1 && /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value);
    case ID_COLUMN:
        return true;
    default:
        return false;
    }
}

class TableWrapper extends React.PureComponent {
    render() {
        return <HotTable 
            ref={component => this.props.setTable(component)} {...this.props}
            settings={{
                data: this.handsontableData,
                colHeaders: true,
                rowHeaders: true
              }}
              licenseKey="non-commercial-and-evaluation"
            />;
    }
}

export default class MassAdd extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    state = {
        data: [],
        error: true,
        serverErrors: [],
    };

    errors = [[true]];

    contextMenu = {
        items: {
            row_above: {
                name: window.gettext('Insert Row Above'),
            },
            row_below: {
                name: window.gettext('Insert Row Below'),
            },
            hsep1: '---------',
            remove_row: {
                name: window.gettext('Remove Row'),
            },
            hsep2: '---------',
            undo: {
                name: window.gettext('Undo'),
            },
            redo: {
                name: window.gettext('Redo'),
            },
        },
    }

    columns = [
        {
            renderer: 'mhelli.name',
            editor: this.handsonEditor,
            width: 120,
        },
        {
            renderer: 'mhelli.name',
            editor: this.handsonEditor,
            width: 130,
        },
        {
            renderer: 'mhelli.nationalId',
            editor: this.handsonEditor,
            width: 95,
        },
        {
            renderer: 'mhelli.class',
            editor: this.handsonEditor,
            width: 50,
        },
        {
            renderer: 'mhelli.gender',
            editor: this.handsonEditor,
            width: 150,
        },
        {
            renderer: 'mhelli.emptyName',
            editor: this.handsonEditor,
            width: 110,
        },
        {
            renderer: 'mhelli.username',
            editor: this.handsonEditor,
            width: 100,
        },
        {
            renderer: 'mhelli.password',
            editor: this.handsonEditor,
            width: 100,
        },
        {
            renderer: 'mhelli.address',
            editor: this.handsonEditor,
            width: 160,
        },
        {
            renderer: 'mhelli.cellPhone',
            editor: this.handsonEditor,
            width: 105,
        },
        {
            renderer: 'mhelli.email',
            editor: this.handsonEditor,
            width: 135,
        },
        {
            renderer: 'mhelli.id',
            editor: this.handsonEditor,
            width: 75,
            readOnly: true,
        },
    ]

    colHeaders = [
        window.gettext('Firstname'),
        window.gettext('Lastname'),
        window.gettext('National ID'),
        window.gettext('Class'),
        window.gettext("جنسیت (مرد ۱ ، زن ۲)"),
        window.gettext('Father Name'),
        window.gettext('Username'),
        window.gettext('Password'),
        window.gettext('Address'),
        window.gettext('Cell Phone'),
        window.gettext('Email'),
        window.gettext('ID'),
    ]

    rowHeaders(index) {
        return (index + 1).persian();
    }

    async afterCreateRow(row) {
        if (!this.table)
            return;
        const data = this.table.hotInstance.getData();
        this.errors.splice(row, 0, []);
        this.errors.splice(data.length);
        this.errors[row] = _.map(data[row], (value, col) => !checkValue(row, col, value, data));
        await window.wait();
        this.setState(update(this.state, {
            error: {$set: _.some(this.errors, row => _.some(row))},
            serverErrors: {$splice: [[row, 0, []]]},
        }));
    }

    async afterRemoveRow(row, amount) {
        if (!this.table)
            return;
        const data = this.table.hotInstance.getData();

        this.errors.splice(row, amount);
        this.errors.splice(data.length);
        await window.wait();
        this.setState(update(this.state, {
            error: {$set: _.some(this.errors, row => _.some(row))},
            serverErrors: {$splice: [[row, amount]]},
        }));
    }

    beforeChange(change) {
        if (!this.table)
            return;
        const data = _.cloneDeep(this.table.hotInstance.getData());
        _.forEach(change, ([row, col,, value], index) => {
            this.errors[row] = _.map(
                data[row],
                (value_, col_) => !checkValue(row, col_, col_ === col ? value.persian() : value_, data),
            );
            if (value && value !== value.persian())
                change[index][3] = value.persian();
            if (this.state.serverErrors[row] && (
                this.state.serverErrors[row][FIELDS[col]] ||
                this.state.serverErrors[row][FIELDS[col]] === false
            ))
                this.setState(update(this.state, {serverErrors: {
                    $splice: [[row, 1, update(this.state.serverErrors[row], {[FIELDS[col]]: {$set: undefined}})]],
                }}));
        });
        this.errors.splice(data.length);
        this.setState({error: _.some(this.errors, row => _.some(row))});
    }

    setTable(table) {
        this.table = table;
    }

    constructor(props) {
        super(props);
        this.classes = {};
        this.rowHeaders = this.rowHeaders.bind(this);
        this.afterCreateRow = this.afterCreateRow.bind(this);
        this.afterRemoveRow = this.afterRemoveRow.bind(this);
        this.beforeChange = this.beforeChange.bind(this);
        this.setTable = this.setTable.bind(this);
    }

    componentWillMount() {
        const temporaryElement = document.createElement('span');
        temporaryElement.innerHTML = window.handsontable_stylesheet;
        document.head.appendChild(temporaryElement.childNodes[0]);

        const massAddInstance = this;

        function basicRenderer(instance, td, row, col, prop, value) {
            Handsontable.renderers.HtmlRenderer.apply(this, arguments);
            const data = massAddInstance.table ? massAddInstance.table.hotInstance.getData() : [];
            if (!checkValue(row, col, value, data)) {
                td.style.backgroundColor = styles.alertBackColor;
                td.style.borderColor = styles.alertBorderColor;
                td.style.color = styles.alertColor;
                td.setAttribute('title', '');
            }
            else if (massAddInstance.state.serverErrors[row]) {
                if (massAddInstance.state.serverErrors[row][FIELDS[col]]) {
                    td.style.backgroundColor = styles.alertBackColor;
                    td.style.borderColor = styles.alertBorderColor;
                    td.style.color = styles.alertColor;
                    td.setAttribute('title', massAddInstance.state.serverErrors[row][FIELDS[col]].join('\n'));
                }
                else if (massAddInstance.state.serverErrors[row][FIELDS[col]] === false) {
                    td.style.backgroundColor = styles.successBackColor;
                    td.style.borderColor = styles.successBorderColor;
                    td.style.color = styles.successColor;
                    td.setAttribute('title', '');
                }
            }
            else {
                td.style.backgroundColor = '';
                td.style.borderColor = '';
                td.style.color = '';
                td.setAttribute('title', '');
            }
        }

        Handsontable.renderers.registerRenderer('mhelli.name', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
        });
        Handsontable.renderers.registerRenderer('mhelli.emptyName', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
        });
        Handsontable.renderers.registerRenderer('mhelli.class', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.textAlign = 'center';
        });
        Handsontable.renderers.registerRenderer('mhelli.gender', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
        });
        Handsontable.renderers.registerRenderer('mhelli.nationalId', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
            td.style.textAlign = 'center';
        });
        Handsontable.renderers.registerRenderer('mhelli.cellPhone', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
            td.style.textAlign = 'center';
        });
        Handsontable.renderers.registerRenderer('mhelli.username', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
            td.style.textAlign = 'center';
        });
        Handsontable.renderers.registerRenderer('mhelli.password', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
            td.style.textAlign = 'center';
        });
        Handsontable.renderers.registerRenderer('mhelli.email', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'ltr';
        });
        Handsontable.renderers.registerRenderer('mhelli.address', function(instance, td) {
            basicRenderer.apply(this, arguments);
            td.style.direction = 'rtl';
        });
        Handsontable.renderers.registerRenderer('mhelli.id', function() {
            basicRenderer.apply(this, arguments);
        });

        this.handsonEditor = Handsontable.editors.TextEditor.prototype.extend();
        this.handsonEditor.prototype.beginEditing = function() {
            Handsontable.editors.TextEditor.prototype.beginEditing.apply(this, arguments);

            this.TEXTAREA.style.fontFamily = 'IRANSans';
            this.TEXTAREA.setAttribute('type', 'password');
        };
    }

    componentWillUnmount() {
    }

    render() {
        return <div>
            {this.state.error
                ? <div
                    style={{
                        color: styles.alertColor,
                        backgroundColor: styles.alertBackColor,
                        border: `.0625em solid ${styles.alertBorderColor}`,
                        padding: '.5em',
                        float: 'left',
                        marginRight: '.5em',
                    }}>
                    {window.gettext('Fix errors in red cells')}
                </div>
                : null
            }
            {!this.state.error && this.props.store.getIn(['schoolsTree', 'selected']).size > 0 && this.props.store.getIn(['gradesTree', 'selected']).size > 0
                ? <button
                    style={{
                        ...styles.defaultButton,
                        float: 'left',
                        marginRight: '.5em',
                    }}
                    onClick={async () => {
                        const data = _.map(
                            this.table.hotInstance.getData(),
                            row => [row[0] , row[1] , row[2] , row[3] , row[4] , row[5] , row[6] || row[2] , row[7] || row[2] , row[8] , row[9] , row[10] ,row[11]]
                        );

                        try {
                            let isClientExist = Boolean(this.props.store.getIn(['clientTree', 'selected']).keySeq().first())
                            await this.context.store.dispatch(request({
                                path: '/student/',
                                body: _.map(
                                    _.filter(data, row => !row[ID_COLUMN]),
                                    row => ({
                                        ..._.mapValues(
                                            _.mapKeys(
                                                _.filter(_.map(Array(10), (__, index) => index), col => row[col]),
                                                col => FIELDS[col],
                                            ),
                                            col => col === CLASS_COLUMN
                                                ? {name: row[col], school: {id: this.props.store.getIn(['schoolsTree', 'selected']).keySeq().first()}}
                                                : _.includes([USERNAME_COLUMN, PASSWORD_COLUMN, NATIONAL_ID_COLUMN, CELL_PHONE_COLUMN , GENDER_COLUMN], col)
                                                    ? row[col].english()
                                                    : row[col]
                                        ),
                                        school: {id: this.props.store.getIn(['schoolsTree', 'selected']).keySeq().first()},
                                        city: {id: this.props.store.getIn(['citiesTree', 'selected']).keySeq().first()},
                                        grade: {id: this.props.store.getIn(['gradesTree', 'selected']).keySeq().first()},
                                        ...(isClientExist ? { client:{id:this.props.store.getIn(['clientTree', 'selected']).keySeq().first()} } : null)
                                    }),
                                ),
                            }));
                            
                            this.setState({data: _.filter(this.state.data, row => row[ID_COLUMN])});
                            await this.context.store.dispatch(request({
                                path: '/student/',
                                body: _.map(
                                    _.filter(data, row => row[ID_COLUMN]),
                                    row => ({
                                        ..._.mapValues(
                                            _.mapKeys(
                                                _.filter(_.map(Array(11), (__, index) => index), col => row[col]),
                                                col => FIELDS[col],
                                            ),
                                            col => col === CLASS_COLUMN
                                                ? row[col] ? {id: this.classes[row[col]]} : null
                                                : _.includes([USERNAME_COLUMN, PASSWORD_COLUMN, NATIONAL_ID_COLUMN, CELL_PHONE_COLUMN, GENDER_COLUMN], col)
                                                    ? row[col].english()
                                                    : row[col]
                                        ),
                                        school: {id: this.props.store.getIn(['schoolsTree', 'selected']).keySeq().first()},
                                        city: {id: this.props.store.getIn(['citiesTree', 'selected']).keySeq().first()},
                                        grade: {id: this.props.store.getIn(['gradesTree', 'selected']).keySeq().first()},
                                        ...(isClientExist ? { client:{id:this.props.store.getIn(['clientTree', 'selected']).keySeq().first()} } : null),
                                        id : row[ID_COLUMN].english()
                                    }),
                                ),
                                method: 'PATCH',
                            }));
                            this.errors = [[true]];
                            this.setState({data: [], success: true});
                            setTimeout(() => this.setState({success: undefined}), 2000);
                        }
                        catch (errors) {
                            let isClientExist = Boolean(this.props.store.getIn(['clientTree', 'selected']).keySeq().first())
                            const data = this.table.hotInstance.getData();
                            const checkResult = await this.context.store.dispatch(request({
                                path: '/student/check_mass_add/',
                                body: _.map(
                                    _.filter(data, row => !row[ID_COLUMN]),
                                    row => ({
                                        ..._.mapValues(
                                            _.mapKeys(
                                                _.filter(_.map(Array(10), (__, index) => index), col => row[col]),
                                                col => FIELDS[col],
                                            ),
                                            col => col === CLASS_COLUMN
                                                ? row[col]
                                                : _.includes([USERNAME_COLUMN, PASSWORD_COLUMN, NATIONAL_ID_COLUMN, CELL_PHONE_COLUMN , GENDER_COLUMN], col)
                                                    ? row[col].english()
                                                    : row[col]
                                        ),
                                        school: {id: this.props.store.getIn(['schoolsTree', 'selected']).keySeq().first()},
                                        city: {id: this.props.store.getIn(['citiesTree', 'selected']).keySeq().first()},
                                        grade: {id: this.props.store.getIn(['gradesTree', 'selected']).keySeq().first()},
                                        ...(isClientExist ? { client:{id:this.props.store.getIn(['clientTree', 'selected']).keySeq().first()} } : null)
                                    }),
                                ),
                            }));
                            _.forEach(checkResult, (result, row) => {
                                if (result) {
                                    this.classes = {...this.classes, ...result['clazz']};
                                    data[row][ID_COLUMN] = result['id'].persian();
                                    this.table.hotInstance.setDataAtCell(row, ID_COLUMN, result['id'].persian());
                                    if (result['firstname'] !== data[row][FIRSTNAME_COLUMN]) {
                                        data[row][FIRSTNAME_COLUMN] = data[row][FIRSTNAME_COLUMN] + ' / '+ result['firstname'].persian();
                                    }
                                    if (result['lastname'] !== data[row][LASTNAME_COLUMN]) {
                                        data[row][LASTNAME_COLUMN] = data[row][LASTNAME_COLUMN] + ' / '+ result['lastname'].persian();
                                    }
                                }
                            });
                            errors = _.map(errors, (rowData, row) => ({
                                ..._.mapValues(
                                    _.mapKeys(
                                        _.map(Array(10), (__, index) => index),
                                        col => FIELDS[col],
                                    ),
                                    () => false,
                                ),
                                ...rowData,
                                ...!data[row][COLUMNS['username']]
                                    ? {username: false}
                                    : {},
                                ...!data[row][COLUMNS['password']]
                                    ? {username: false}
                                    : {},
                            }));
                            this.setState({serverErrors: errors, success: false, data});
                            setTimeout(() => this.setState({success: undefined}), 2000);
                        }
                    }}>
                    {window.gettext('Upload')}
                </button>
                : null
            }
            <button
                style={{
                    ...styles.button,
                    float: 'left',
                    marginRight: '.5em',
                }}
                onClick={() => {
                    const path = this.context.store.getState().getIn(
                        ['routing', 'locationBeforeTransitions', 'pathname'],
                    );
                    this.context.store.dispatch(push(path.split('/').slice(0, -2).join('/') + '/'));
                }}>
                {window.gettext('Return to List')}
            </button>
            {_.intersection(this.context.user.type, ['admin', 'clinet'])
                ? [
                    <div
                        key='region'
                        style={{
                            float: 'right',
                            width: '14%',
                            marginLeft: '.5em',
                            fontSize: '.8em',
                        }}>
                        <Tree
                            store={this.props.store.get('regionsTree')}
                            readonly
                            resource='region'
                            itemLabel='name'
                            multiSelection={false}
                            combobox
                            label={window.gettext('Region')}
                        />
                    </div>,
                    <div
                        key='city'
                        style={{
                            float: 'right',
                            width: '14%',
                            marginLeft: '.5em',
                            fontSize: '.8em',
                        }}>
                        <Tree
                            store={this.props.store.get('citiesTree')}
                            readonly
                            resource='city'
                            itemLabel='name'
                            multiSelection={false}
                            combobox
                            label={window.gettext('City')}
                            filter={{
                                region: this.props.store.getIn(['regionsTree', 'selected']).keySeq().join(',') || -1,
                            }}
                        />
                    </div>,
                    <div
                        key='school'
                        style={{
                            float: 'right',
                            width: '13%',
                            marginLeft: '.5em',
                            fontSize: '.8em',
                        }}>
                        <Tree
                            store={this.props.store.get('schoolsTree')}
                            readonly
                            resource='school'
                            itemLabel={school => `${school.name} -` +
                                    ` ${_.map(school.levels, level => level.title).join(window.gettext(','))}`}
                            multiSelection={false}
                            combobox
                            label={window.gettext('School')}
                            filter={{
                                city: this.props.store.getIn(['citiesTree', 'selected']).keySeq().join(',') || -1,
                            }}
                        />
                    </div>,
                    <div
                    style={{
                        float: 'right',
                        width: '13%',
                        marginLeft: '.5em',
                        fontSize: '.8em',
                    }}
                    >
                        <Tree
                            store={this.props.store.get('clientTree')}
                            style={{
                                border: styles.field.border,
                            }}
                            readonly
                            resource='client'
                            multiSelection={false}
                            combobox
                            itemLabel={["title"]}
                            label={window.gettext('Special Client')}
                            filter={{
                                client: this.props.store.getIn(['clientTree', 'selected']).keySeq().join(',') || -1,
                                is_special : true
                            }}
                        />
                    </div>
                ]
                : null
            }
            <div
                key='grade'
                style={{
                    float: 'right',
                    width: '11%',
                    marginLeft: '.5em',
                    fontSize: '.8em',
                }}>
                <Tree
                    store={this.props.store.get('gradesTree')}
                    readonly
                    resource='grade'
                    itemLabel='title'
                    multiSelection={false}
                    combobox
                    label={window.gettext('Grade')}
                />
            </div>
            <Style
                rules={{
                    '.ht_clone_top': {
                        zIndex: '1 !important',
                    },
                }}
            />
            <div style={{direction: 'ltr', float: 'left', clear: 'both', marginTop: '1em'}}>
                <TableWrapper
                    data={this.state.data}
                    undo
                    copyPaste
                    contextMenu={this.contextMenu}
                    allowInsertColumn={false}
                    allowRemoveColumn={false}
                    columns={this.columns}
                    colHeaders={this.colHeaders}
                    rowHeaders={this.rowHeaders}
                    minRows={1}
                    afterCreateRow={this.afterCreateRow}
                    afterRemoveRow={this.afterRemoveRow}
                    beforeChange={this.beforeChange}
                    setTable={this.setTable}
                />
            </div>
        </div>;
    }
}
